/**
 * Buttons Component
 *
 * Global button click tracking for WordPress buttons and outbound links
 */

import { trackCtaClick, trackOutboundLinkClick } from '../analytics';

const Buttons = (function($) {

  // Selectors
  const _s = {
    button: 'a.wp-block-button__link',
    link: 'a[href]'
  };

  // Initialize
  const _init = function() {
    _bindEvents();
  };

  // Check if link is external/outbound
  const _isOutboundLink = function(url) {
    if (!url) return false;
    
    // Skip anchor links, mailto, tel, etc.
    if (url.startsWith('#') || url.startsWith('mailto:') || url.startsWith('tel:')) {
      return false;
    }
    
    // Get current site domain
    const currentDomain = window.location.hostname;
    
    try {
      // Parse the URL
      const link = new URL(url, window.location.origin);
      
      // Check if hostname is different from current site
      return link.hostname !== currentDomain;
    } catch (e) {
      // If URL parsing fails, assume it's internal
      return false;
    }
  };

  // Bind Events
  const _bindEvents = function() {
    // Track button clicks (internal CTAs)
    $(document).on('click', _s.button, function() {
      const $button = $(this);
      const linkUrl = $button.attr('href');
      const linkText = $button.text().trim();
      
      if (linkUrl && linkText) {
        trackCtaClick(linkText, linkUrl);
      }
    });

    // Track outbound link clicks
    $(document).on('click', _s.link, function(e) {
      const $link = $(this);
      const linkUrl = $link.attr('href');
      const linkText = $link.text().trim();
      
      // Skip if it's a button (already tracked above)
      if ($link.hasClass('wp-block-button__link')) {
        return;
      }
      
      // Only track if it's an outbound link
      if (_isOutboundLink(linkUrl) && linkText) {
        trackOutboundLinkClick(linkText, linkUrl);
      }
    });
  };

  // Public API
  return {
    init: _init
  };

})(jQuery);

export default Buttons;
